import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
declare var $: any;
import { S3UploadService } from '../../services/s3-upload.service'
import { UtilityService } from 'src/app/services/utility.service';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';

@Component({
  selector: 'app-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.scss']
})
export class SignaturePadComponent implements OnInit {
  @ViewChild(SignaturePad, { static: true }) signaturePad: SignaturePad;

  public signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
    'minWidth': 2,
    'canvasWidth': 500,
    'canvasHeight': 500
  };

  imgData;
  parentWidth;
  canvas;
  testdata: any;
  displayMsg: boolean;
  loading: boolean = false;
  constructor(
    public _s3UploadService: S3UploadService,
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _utilityService: UtilityService,
    public _encryptDecryptService: EncryptDecryptService
  ) { }

  ngOnInit() {
    this.canvas = document.querySelector("canvas");
    if (screen.width > 767) {
      console.log(" > 767");
      this.canvas.width = 500
      this.canvas.height = 500
    } else if (screen.width < 767 && screen.width >= 575) {
      this.canvas.width = 420
      this.canvas.height = 420
    } else if (screen.width < 575 && screen.width >= 420) {
      this.canvas.width = 350
      this.canvas.height = 350
    } else if (screen.width < 420 && screen.width >= 380) {
      this.canvas.width = 300
      this.canvas.height = 300
    } else if (screen.width < 380) {
      this.canvas.width = 260
      this.canvas.height = 260
    }
    this.checkSessionStorage()

  }

  checkSessionStorage() {
    const sessionStorageData = JSON.parse(sessionStorage.getItem('auth'))
    if (sessionStorageData) {
      console.log("SESSION storage data: ", sessionStorageData.primary, sessionStorageData.secondary)
    } else {
      this._utilityService.updatePlatformData().subscribe((data) => {
        console.log("SESSION storage data", data)
        const credentials = this._encryptDecryptService.platFormDecrypt(data)
        console.log("SESSION storage credentials: ", credentials)
        sessionStorage.setItem('auth', credentials);
      })
    }
  }

  ngAfterViewInit() {
    this.signaturePad.clear();
  }

  drawComplete() {
    // will be notified of szimek/signature_pad's onEnd event
    this.imgData = this.signaturePad.toDataURL('image/png')
    this.trimCanvas(this.canvas)
    // console.log(this.signaturePad.toDataURL());
  }


  clear() {

    console.log('Clear Calling');

    this.imgData = null
    this.signaturePad.clear();
  }

  drawStart() {
    // will be notified of szimek/signature_pad's onBegin event
    console.log('begin drawing');
  }

  trimCanvas(c) {
    let ctx = c.getContext('2d'),
      copy = document.createElement('canvas').getContext('2d'),
      pixels = ctx.getImageData(0, 0, c.width, c.height),
      l = pixels.data.length,
      i,
      bound = {
        top: null,
        left: null,
        right: null,
        bottom: null
      },
      x, y;

    // Iterate over every pixel to find the highest
    // and where it ends on every axis ()
    for (i = 0; i < l; i += 4) {
      if (pixels.data[i + 3] !== 0) {
        x = (i / 4) % c.width;
        y = ~~((i / 4) / c.width);

        if (bound.top === null) {
          bound.top = y;
        }

        if (bound.left === null) {
          bound.left = x;
        } else if (x < bound.left) {
          bound.left = x;
        }

        if (bound.right === null) {
          bound.right = x;
        } else if (bound.right < x) {
          bound.right = x;
        }

        if (bound.bottom === null) {
          bound.bottom = y;
        } else if (bound.bottom < y) {
          bound.bottom = y;
        }
      }
    }

    // Calculate the height and width of the content
    let trimHeight = bound.bottom - bound.top,
      trimWidth = bound.right - bound.left,
      trimmed = ctx.getImageData(bound.left, bound.top, trimWidth, trimHeight);
    console.log("trimmed", trimmed)
    //  this.testdata = trimmed.data
    copy.canvas.width = trimWidth;
    copy.canvas.height = trimHeight;
    copy.putImageData(trimmed, 0, 0);

    // Return trimmed canvas
    console.log('copy.canvas;', copy.canvas.toDataURL())
    console.log(" copy.putImageData(trimmed, 0, 0);", copy.putImageData(trimmed, 0, 0))
    this.testdata = copy.canvas.toDataURL()
    return copy.canvas;
  }

  submit() {
    this.loading = true
    this.displayMsg = false
    if (!this.signaturePad.isEmpty()) {
      this._s3UploadService.uploadSignatureBase64(this.testdata).subscribe(res => {
        console.log("res in signature ==> ", res)
        this.dialogRef.close(res.Location)
        this.loading = false
      })
    }
    else {
      this.loading = false
      this.displayMsg = true
    }
    // this.dialogRef.close(this.testdata)
    // if(this.signaturePad.isEmpty()){
    //   alert("IS EMPTY")
    // }
    // else{
    //   this.dialogRef.close(this.testdata)
    // }
  }

}
